/**
 *
 * @param {type} el
 * @returns {undefined}
 */
oyc.untouch = function (el) {
  if (typeof el === 'undefined') {
    return;
  }
  el.blur();
  var par = el.parentNode;
  var next = el.nextSibling;
  par.blur();
  par.removeChild(el);
  var par2 = par.parentNode;
  par2.blur();
  setTimeout(function () {
    par.insertBefore(el, next);
  }, 0);
}
